import { render, staticRenderFns } from "./ImgScreen.vue?vue&type=template&id=0ad430fc&scoped=true&"
import script from "./ImgScreen.vue?vue&type=script&lang=js&"
export * from "./ImgScreen.vue?vue&type=script&lang=js&"
import style1 from "./ImgScreen.vue?vue&type=style&index=1&id=0ad430fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad430fc",
  null
  
)

export default component.exports